import i18n from '@/i18n';
import { getInfoUserLocalStorage } from '@/utils/handlers';

const TYPE_TEMPLATE = {
    INVITE: 1,
    THANK_YOU: 2
};

const configListTemplate = {
    title: '',
    model: false,
    scrollable: true,
    hideFooter: true,
    class: 'h-100',
    size: 'lg',
    validate: true
};

const FORM_SEND_MAIL = () => {
    return {
        invite_mail_send_test: getInfoUserLocalStorage()?.email ?? ''
    };
};
const configSendMail = () => {
    return {
        invite_mail_send_test: {
            placeholder: i18n.t('managerForm.settingPage.pageTypeI.testEmailPlaceholder'),
            error: false,
            errorField: i18n.t('managerForm.settingPage.pageTypeI.testEmailPlaceholder'),
            typesValidate: ['email', 'max255']
        }
    };
};

const initForm = () => {
    return {
        type: 'text',
        invite: {
            subject: 'パルディアからのフォーム',
            template: null,
            email_sender: null,
            body: '',
            type: 'text'
        }
    };
};

const configForm = () => {
    return {
        invite: {
            subject: {
                error: false,
                errorField: i18n.t('managerForm.settingPage.pageTypeI.invite.emailSubject'),
                typesValidate: ['required', 'max255']
            },
            template: {
                trackBy: 'id',
                label: 'template_name',
                errorField: i18n.t('managerForm.settingPage.pageTypeI.invite.templateSelection'),
                error: false,
                isRemove: false,
                typesValidate: []
            },
            email_sender: {
                trackBy: 'id',
                label: 'label_mail',
                errorField: i18n.t('managerForm.settingPage.pageTypeI.invite.senderEmail'),
                error: false,
                isRemove: true,
                loading: false,
                typesValidate: ['requiredSelect']
            },
            body: {
                error: false,
                length: 3000,
                errorField: i18n.t('managerForm.settingPage.pageTypeI.invite.emailBody'),
                typesValidate: ['requiredCustomMsg', 'maxCustom']
            },
            type: {
                error: false,
                errorField: i18n.t('managerForm.settingPage.pageTypeI.emailFormat'),
                typesValidate: []
            }
        }
    };
};

const configModalTempMailI = {
    title: 'テンプレート',
    model: false,
    scrollable: true,
    hideFooter: false,
    validate: true,
    centered: true,
    size: 'lg'
};
const optionSendType = [
    {
        id: 1,
        label: i18n.t('managerForm.settingPage.pageTypeI.filedText'),
        value: 'text'
    },
    {
        id: 2,
        label: 'HTML',
        value: 'html'
    }
];
const initFormTempMailI = () => {
    return {
        name_template: ''
    };
};
const configFormTempMailI = () => {
    return {
        name_template: {
            error: false,
            errorField: i18n.t('managerForm.temporarily.nameTemp'),
            typesValidate: ['required', 'max255']
        }
    };
};
export {
    FORM_SEND_MAIL,
    configSendMail,
    initForm,
    configForm,
    initFormTempMailI,
    configFormTempMailI,
    configModalTempMailI,
    optionSendType,
    TYPE_TEMPLATE,
    configListTemplate
};
